import React from 'react';
import { Typography, Row, Col, Card, Skeleton } from 'antd';
import { useAboutContent, getContentByKey } from '../../hooks/useDynamicContent';

function About() {
    const { content: aboutContent, loading: contentLoading } = useAboutContent();
    
    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl lg:mx-0">
                    <Typography.Title level={1} className="!text-3xl sm:!text-4xl !mb-6">
                        {contentLoading ? (
                            <Skeleton.Input active size="large" style={{ width: '80%' }} />
                        ) : (
                            getContentByKey(aboutContent, 'about_title', 'About Spoon & Spice')
                        )}
                    </Typography.Title>
                    <Typography.Paragraph className="!text-lg !text-gray-600 !leading-8">
                        {contentLoading ? (
                            <Skeleton.Input active size="default" style={{ width: '100%' }} />
                        ) : (
                            getContentByKey(aboutContent, 'about_description', 'We are India\'s premier catering platform, connecting customers with the best caterers and restaurants across major cities.')
                        )}
                    </Typography.Paragraph>
                </div>
                <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
                    <Row gutter={[32, 32]}>
                        <Col xs={24} lg={8}>
                            <Card hoverable className="h-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group">
                                <Typography.Title level={3} className="!mb-4 group-hover:text-indigo-600 transition-colors">Our Mission</Typography.Title>
                                <Typography.Paragraph className="!text-gray-600 !mb-0">
                                    To make quality catering accessible and convenient for every occasion, big or small.
                                </Typography.Paragraph>
                            </Card>
                        </Col>
                        <Col xs={24} lg={8}>
                            <Card hoverable className="h-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group">
                                <Typography.Title level={3} className="!mb-4 group-hover:text-indigo-600 transition-colors">Our Vision</Typography.Title>
                                <Typography.Paragraph className="!text-gray-600 !mb-0">
                                    To become the go-to platform for all catering needs across India.
                                </Typography.Paragraph>
                            </Card>
                        </Col>
                        <Col xs={24} lg={8}>
                            <Card hoverable className="h-full hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group">
                                <Typography.Title level={3} className="!mb-4 group-hover:text-indigo-600 transition-colors">Our Values</Typography.Title>
                                <Typography.Paragraph className="!text-gray-600 !mb-0">
                                    Quality, reliability, and customer satisfaction are at the heart of everything we do.
                                </Typography.Paragraph>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default About;
